module.exports = __webpack_public_path__ + "img/apple-music-icon.4b946ae3.svg";